import React, { useState, useRef, useEffect } from "react";

interface IProps {
    label?: string;
    options: { id: string; name: string; cost: number }[];
    selectedIds: string[];
    onChange: (ids: string[]) => void;
}

export const PortalMultiSelect: React.FC<IProps> = props => {
    const { label, options, selectedIds, onChange } = props;

    const [open, setOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    // Close on outside click
    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const selectedNames = options
        .filter(o => selectedIds.includes(o.id))
        .map(o => o.name)
        .join(", ");

    const toggleId = (id: string) => {
        let newIds;

        if (selectedIds.includes(id)) {
            // remove id
            newIds = selectedIds.filter(function(x) {
                return x !== id;
            });
        } else {
            // add id (concat does not mutate)
            newIds = selectedIds.concat(id);
        }

        onChange(newIds);
    };

    return (
        <div style={{ width: 271 }} ref={containerRef}>
            <label
                style={{
                    fontSize: 12,
                    marginBottom: 4,
                    display: "block",
                    color: "#444",
                }}
            >
                {label}
            </label>

            <div
                style={{
                    height: 32,
                    display: "flex",
                    /* UI Properties */
                    background: "#FFFFFF 0% 0% no-repeat padding-box",
                    border: "1px solid #CED4DA",
                    opacity: "1",
                    padding: "8px 11px",
                }}
                onClick={() => setOpen(prev => !prev)}
            >
                <span style={{ flex: 1, color: selectedNames ? "#000" : "#999", overflow: "hidden" }}>{selectedNames || "Select..."}</span>
                <span style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
            </div>

            {open && (
                <div
                    style={{
                        position: "absolute",
                        width: 271,
                        border: "1px solid #ccc",
                        background: "#fff",
                        borderRadius: 4,
                        marginTop: 2,
                        maxHeight: 200,
                        overflowY: "auto",
                        zIndex: 999,
                    }}
                >
                    {options.map(option => (
                        <label
                            key={option.id}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 8px",
                                cursor: "pointer",
                                fontSize: 14,
                            }}
                            onClick={() => toggleId(option.id)}
                        >
                            <input type="checkbox" checked={selectedIds.includes(option.id)} readOnly style={{ marginRight: 8 }} />
                            <div style={{ flex: 1 }}>
                                <div>{option.name}</div>
                                <div style={{ fontSize: 12, color: "#666" }}>£{option.cost.toFixed(2)}</div>
                            </div>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};
